"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationType = exports.CreatedByType = exports.AssetPropType = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
const CreatedByType = prop_types_1.default.shape({
    profilePhoto: prop_types_1.default.string,
    firstName: prop_types_1.default.string,
    lastName: prop_types_1.default.string
});
exports.CreatedByType = CreatedByType;
const OrganizationType = prop_types_1.default.shape({
    id: prop_types_1.default.string.isRequired,
    domain: prop_types_1.default.string
});
exports.OrganizationType = OrganizationType;
const AssetPropType = prop_types_1.default.shape({
    id: prop_types_1.default.string,
    type: prop_types_1.default.string.isRequired,
    files: prop_types_1.default.arrayOf(prop_types_1.default.object),
    rating: prop_types_1.default.number,
    name: prop_types_1.default.string.isRequired,
    createdBy: CreatedByType,
    organization: OrganizationType.isRequired,
    icon: prop_types_1.default.string,
    status: prop_types_1.default.string,
    createdAt: prop_types_1.default.string,
    modifiedAt: prop_types_1.default.string,
    publishedAt: prop_types_1.default.string
});
exports.AssetPropType = AssetPropType;
